import client from "./client";

const getCountries = () => client.get("/subsidiary/dashboard/service/countries");

export default { getCountries };
